import { listNovelPacks, publishNovelPack, unpublishNovelPack, listNovelReviews } from '../api/index.js'

/** Load every source page before applying the combined search and pagination. */
export async function loadManagedGames(api) {
  const [scenarios, first_page, reviews] = await Promise.all([
    api.visualGame.listPacks(),
    listNovelPacks({ page: 1, page_size: 100 }),
    listNovelReviews('approved'),
  ])
  const stories = [...first_page.items]
  for (let page = 2; page <= first_page.pages; page += 1) {
    stories.push(...(await listNovelPacks({ page, page_size: 100 })).items)
  }
  return [
    ...scenarios.packs.map(pack => {
      const has_release = Boolean(pack.current_version_id) && ['published', 'coming_soon'].includes(pack.status)
      return { ...pack, game_type: 'scenario', key: `scenario:${pack.id}`,
        listed: has_release && pack.visibility === 'public',
        blocked: has_release ? '' : 'versionRequired' }
    }),
    ...stories.map(pack => {
      // Keep a re-list tied to the previously published snapshot when available.
      const candidates = reviews.items.filter(review => review.pack_id === pack.id && review.preparation_status === 'ready')
      const review = candidates.find(item => item.version_id === pack.published_version_id)
        ?? candidates.sort((left, right) => right.created_at.localeCompare(left.created_at))[0]
      return { ...pack, game_type: 'story', key: `story:${pack.id}`, listed: pack.status === 'published',
        review_id: review?.id,
        blocked: ['archived', 'deleted'].includes(pack.status) ? 'unavailable' : review ? '' : 'reviewRequired' }
    }),
  ].sort((left, right) => (new Date(right.updated_at).getTime() || 0) - (new Date(left.updated_at).getTime() || 0) || left.key.localeCompare(right.key))
}

/** Use existing publication endpoints; the server remains the authority on eligibility. */
export async function setManagedGameListing(api, game, listed) {
  if (game.game_type === 'story') {
    return listed ? publishNovelPack(game.id, game.review_id) : unpublishNovelPack(game.id)
  }
  return api.visualGame.updatePack({ id: game.id, visibility: listed ? 'public' : 'private' })
}
